module.exports = __webpack_public_path__ + "img/Saloons.19a2d9be.svg";